import { useQuery } from '@tanstack/vue-query'

import { explorerApi } from '~/api/client'
import { NexonLwCirculatingSupplyTrackerRequest } from '~/api/repository'

export const getLivewatchCirculatingSupplyTracker = () => {
  return useQuery({
    queryKey: [ 'livewatchCirculatingSupplyTracker' ],
    queryFn: () => explorerApi.lwController.getCirculatingSupplyTracker({
      requestBody: {
        periodType: NexonLwCirculatingSupplyTrackerRequest.periodType.ALL
      }
    }).then(res => livewatchCirculatingSupplyTrackerDto(res))
  })
}

export type LivewatchCirculatingSupplyTracker = {
    symbol: string;
    circulatingSupplyList: Array<[number, number]>;
    scheduleSupplyList: Array<[number, number]>;
};

export const livewatchCirculatingSupplyTrackerDto = (data: any): LivewatchCirculatingSupplyTracker => {
  return {
    symbol: data.SB,
    circulatingSupplyList: data.CSLIST.map((item: any) => [ Number(item.DT * 1000), Number(item.VAL) ]),
    scheduleSupplyList: data.SSLIST.map((item: any) => [ Number(item.DT * 1000), Number(item.VAL) ]),
  }
}

